declare var jQuery: any;

/**
 * Edit page
 *
 * @return void
 */
const editPage = () => {
  // Get DATAGENT_ORDER
  const { label, order } = (<any>window).DATAGENT_ORDER;

  // Create new chat with coupon button.
  let newButton = jQuery('<a/>', {
    class: 'page-title-action',
    href: order.convert_url.replace(/&amp;/g, '&'),
    text: label.chat_with_order,
  });
  newButton.insertAfter('.page-title-action');
};

// Add buttons on WPForms overview page
jQuery(document).ready(function () {
  // Get action from $_GET['action']
  const urlParams = new URLSearchParams(window.location.search);
  const action = urlParams.get('action');

  if (action === 'edit') {
    // Check if action is edit
    editPage();
  }
});
